import { BASE_URL_V2 } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'PREDICTIVE_GET',
  GET_SUCCESS: 'PREDICTIVE_GET_SUCCESS',
  GET_FAILURE: 'PREDICTIVE_GET_FAILURE',
};

export const get = actions.get(
  sheetId => `${BASE_URL_V2}/nodes/${sheetId}/preload?include_player_config=True`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
